// extracted by mini-css-extract-plugin
export default {"color-tile":"zpuD8KG","color-tile--disabled":"UioMTzw","color-tile--selected":"SjGe8o5","color-tile--tooltip":"e03sJYO"};